'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _initGpt = require('./initGpt');

var _initGpt2 = _interopRequireDefault(_initGpt);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _initLotameTargeting = require('./initLotameTargeting');

var _initLotameTargeting2 = _interopRequireDefault(_initLotameTargeting);

var _initKruxTargeting = require('./initKruxTargeting');

var _initKruxTargeting2 = _interopRequireDefault(_initKruxTargeting);

var _stringHash = require('string-hash');

var _stringHash2 = _interopRequireDefault(_stringHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setTargeting = function setTargeting(slot, targetingData, lotameTargeting) {
  slot.clearTargeting();

  if (lotameTargeting && window.lotameGPTData) {
    slot.setTargeting('ccaud', [window.lotameGPTData]);
  }
  targetingData.map(function (_ref) {
    var key = _ref.key,
        value = _ref.value;

    slot.setTargeting(key, value);
  });
};

var GooglePublisherTag = function (_Component) {
  _inherits(GooglePublisherTag, _Component);

  function GooglePublisherTag(props) {
    _classCallCheck(this, GooglePublisherTag);

    var _this = _possibleConstructorReturn(this, (GooglePublisherTag.__proto__ || Object.getPrototypeOf(GooglePublisherTag)).call(this));

    _this.tagName = (0, _stringHash2.default)(props.tagId).toString();
    _this.debounceRefreshAd = (0, _debounce2.default)(_this.refreshAd, props.debounceTimer);
    return _this;
  }

  _createClass(GooglePublisherTag, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.gt = (0, _initGpt2.default)();
      if (this.props.lotameTargeting) {
        (0, _initLotameTargeting2.default)();
        (0, _initKruxTargeting2.default)();
      }
      this.refreshAd(this.gt, this.tagName, this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currTargeting = JSON.stringify(this.props.targetingData);
      var newTargeting = JSON.stringify(nextProps.targetingData);

      if (currTargeting !== newTargeting) {
        this.debounceRefreshAd(this.gt, this.tagName, nextProps);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'refreshAd',
    value: function refreshAd(gt, tagName, _ref2) {
      var tagId = _ref2.tagId,
          width = _ref2.width,
          height = _ref2.height,
          targetingData = _ref2.targetingData,
          lotameTargeting = _ref2.lotameTargeting;

      gt.cmd.push(function () {
        if (!gt.slots[tagName]) {
          gt.slots[tagName] = gt.defineSlot(tagId, [width, height], tagName).addService(gt.pubads());
          gt.display(tagName);
        }

        // Lotame targetting
        setTargeting(gt.slots[tagName], targetingData, lotameTargeting);

        // Krux targetting
        gt.pubads().setTargeting('ksg', window.Krux.segments);
        gt.pubads().setTargeting('kuid', window.Krux.user);

        if (targetingData && Array.isArray(targetingData)) {
          targetingData.map(function (_ref3) {
            var key = _ref3.key,
                value = _ref3.value;

            if (key === 'experiment') {
              gt.pubads().setTargeting(key, value);
            }
          });
        }

        gt.pubads().refresh([gt.slots[tagName]]);
      });

      this.props.logger();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { id: this.tagName });
    }
  }]);

  return GooglePublisherTag;
}(_react.Component);

GooglePublisherTag.propTypes = {
  tagId: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  debounceTimer: _propTypes2.default.number,
  targetingData: _propTypes2.default.array,
  lotameTargeting: _propTypes2.default.bool,
  logger: _propTypes2.default.func
};
GooglePublisherTag.defaultProps = {
  debounceTimer: 1500,
  targetingData: [],
  lotameTargeting: false,
  logger: function logger() {}
};
exports.default = GooglePublisherTag;